/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 * @author Misha Kokoulin
 * @author Maxim Fedorov
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.25.1
 * @since 1.0.0
 */

/**
 * List of possible cookies.
 * In the future, the list may be updated
 * @type {string[]}
 */
import { EWizardName } from '../wizard/wizardConstants';
import { ECookieKey, ELocalStorageKeys } from './storageTypes';

export const COOKIES = [
    ECookieKey.BANNER_ALTERNATIVE_CLOSED,
    ECookieKey.BANNER_ALTERNATIVE_SHOWED,
    ECookieKey.BILL_PAGE,
    ECookieKey.CACHE_IN_PROGRESS,
    ECookieKey.EXPENSE_ANALYZER_PAGE,
    ECookieKey.VOTING_HIDE,
    ECookieKey.XSRF_TOKEN,
];
export const COOKIES_PARSE = [ECookieKey.DENSITY_LIST_VIEW];
export const COOKIES_FOR_REMOVE = [
    ECookieKey.BANNER_ALTERNATIVE_CLOSED,
    ECookieKey.BANNER_ALTERNATIVE_SHOWED,
    ECookieKey.BILL_PAGE,
    ECookieKey.EXPENSE_ANALYZER_PAGE,
];
export const LOCAL_STORAGE = [
    ELocalStorageKeys.DASHBOARD_SELECTED_ACCOUNT,
    ELocalStorageKeys.CURRENT_USER_ID,
    ELocalStorageKeys.PRODUCTS,
    ELocalStorageKeys.SETTINGS_PROFILE_PARAMS,
    ELocalStorageKeys.TABLE_BTN_ACTIVE,
    ELocalStorageKeys.IS_SUBSCRIBERS_IN_ROAMING_PLATE_HIDDEN,
];

export const LOCAL_STORAGE_FOR_REMOVE = [
    ELocalStorageKeys.DASHBOARD_SELECTED_ACCOUNT,
    ELocalStorageKeys.CURRENT_USER_ID,
    ELocalStorageKeys.LABELS_IMPORT,
    ELocalStorageKeys.PRODUCTS,
    ELocalStorageKeys.SETTINGS_PROFILE_PARAMS,
    ELocalStorageKeys.TABLE_BTN_ACTIVE,
    EWizardName.IMPORT_PERSONAL_DATA,
    EWizardName.CALLS_DETAIL,
    EWizardName.CHANGE_LOCK,
    EWizardName.ADDITIONAL_ACCOUNTS,
    EWizardName.EXPENSES_DETAIL,
    EWizardName.LABELS_IMPORT,
    EWizardName.MONEY_TRANSFER,
    EWizardName.PRODUCT_OFFERINGS,
    EWizardName.PRODUCT_OFFERINGS_CAMPAIGN,
    EWizardName.BILLS_DOC,
    EWizardName.CHANGE_ROLE,
    EWizardName.COLLATION_REPORT,
    EWizardName.ADDITIONAL_REPORTS,
    EWizardName.IMPORT_SUBSCRIBERS_LIMITS,
    ELocalStorageKeys.IS_SUBSCRIBERS_IN_ROAMING_PLATE_HIDDEN,
];

export const SESSION_STORAGE = ['timers'];

export const LOAD_STORAGE_DATA_START = '@@b2b_portal_ui/storage/LOAD_STORAGE_DATA_START';
export const LOAD_STORAGE_DATA_FINISH = '@@b2b_portal_ui/storage/LOAD_STORAGE_DATA_FINISH';
export const REMOVE_STORAGE_DATA_START = '@@b2b_portal_ui/storage/REMOVE_STORAGE_DATA_START';
export const REMOVE_STORAGE_DATA_SUCCESS = '@@b2b_portal_ui/storage/REMOVE_STORAGE_DATA_SUCCESS';
export const REMOVE_COOKIE_DATA = '@@b2b_portal_ui/storage/REMOVE_COOKIE_DATA';
export const SET_COOKIE_DATA = '@@b2b_portal_ui/storage/SET_COOKIE_DATA';
export const SET_LOCAL_STORAGE_DATA = '@@b2b_portal_ui/storage/SET_LOCAL_STORAGE_DATA';
export const SET_SESSION_STORAGE_DATA = '@@b2b_portal_ui/storage/SET_SESSION_STORAGE_DATA';
export const SET_STORAGE_DATA_SUCCESS = '@@b2b_portal_ui/storage/SET_STORAGE_DATA_SUCCESS';
